import React, {useState,useEffect,useContext} from "react";
import rainbowSDK from "rainbow-web-sdk";
import {
  TextField,
  Button,
  Paper,
  Grid,
  CircularProgress,
  Snackbar,
  Typography,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import vurellaACD from "../images/118.png";
import rainbowGif from "../images/rainbowlogo.gif"
import {Context} from "../Context.js";
import MuiAlert from "@material-ui/lab/Alert";
import PersonIcon from "@material-ui/icons/PersonOutline";
import {useTranslation} from "react-i18next";
import rainbowLogo from "../images/rainbow_logo.png";
import { CallMissedSharp } from "@material-ui/icons";

const useStyles = makeStyles((theme) => ({
  root: {
    position:'relative',
    display:'flex',
    height:'90vh',
    justifyContent: 'center',
    paddingTop:'12px',

    "& .MuiTextField-root": {
      margin: theme.spacing(1),
      width: "310px",
    },
    "& .MuiButton-root": {
      margin: theme.spacing(1),
      width: "310px",
      height: "48px",
      backgroundColor:'#0288d1',
    },
  },
  Loginpaper: {
    position:'relative',
    flexGrow: 1,
    padding: theme.spacing(4),
    margin: theme.spacing(4),
    textAlign: "center",
    justifyContent: "center",
    color: '#b3e5fc',
    height: 380 + "px",
  },
  buttonProgress: {
    position:'absolute',
    top: '50%',
    left:'75%',
    marginTop: -12,
    marginLeft: -12,
    color:'white',
  },
  autologin: {
    position: 'relative',
    
  },
  autologinchild: {
    position:'absolute',
    left: '50%',
    top:'50%',
    transform: 'translate(-50%, -50%)',
    width: '200px',
    height: '200px',
    textAlign: 'center'
  }

}));

var isEnterprise = true;
export default function RainbowLogin(props) {
  const {t} = useTranslation();
  const [userAccount,setUserAccount] = useContext(Context);
  const [btnState, setBtnState] = useState(false);
  const [errorOpen, setErrorOpen] = useState(false);
  const [errorMsg, setErrorMsg] = useState('');
  const [userN, setUserName] = useState(localStorage.getItem('username'));
  const [passW, setPassWord] = useState(localStorage.getItem('password'));
  const [autoLogin, setAutoLogin] = useState(false);
  const classes = useStyles();
  
  

  function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
  }


  const handleErrorClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setErrorOpen(false);
  };
  
  const handleSubmit = (event) => {
    event.preventDefault();
    // console.log("submit login fired")
     
    let uname = event.target.elements.username.value;
    let pass = event.target.elements.password.value;
      
    login(uname,pass);
        
        
    };

  function login(username, password)
  {
    setBtnState(true);
    var exten = '';
    //console.log(uname);
    //console.log(pass);
    rainbowSDK.connection
      .signinOnRainbowOfficial(username, password)
      .then(function (account) {
        //console.log("LOGIN SUCCESSFUL");
       
        localStorage.setItem('username',username);
        localStorage.setItem('password',password);
        exten = rainbowSDK.contacts.getConnectedUser().phoneInternalNumber;

        setBtnState(false);
       

        if(rainbowSDK.caps.getUserSubscription().search("Enterprise") == -1)
        {
          setAutoLogin(false);
          rainbowSDK.connection.signout().then(function(data) {

            setErrorOpen(true);
            setErrorMsg(" a Rainbow Enterprise license is  required to use this application.");
            props.onChange(false);
          });

        }
        else
        {
        setUserAccount(userAccount =>({...userAccount,firstname:account.userData.firstName,lastname:account.userData.lastName,name:account.userData.displayName,extension:exten,rainbowloggedin:true,acdloggedin:null,rainbowusername:username,rainbowpassword:password}));
        props.onChange(true); 
        }

      })
      .catch(function (err) {
       // console.log(err);
        setAutoLogin(false);
        setBtnState(false);
        setErrorOpen(true);
        setErrorMsg(err.label);
        props.onChange(false);
      });

  } 
   useEffect(() => {
      //console.log(btnState);

      if(localStorage.getItem('username') !== null && localStorage.getItem('password') !== null)
      {
          
        if(props.initState)
        {
          setAutoLogin(true);
          props.setInitState(false);
          login(localStorage.getItem('username'),localStorage.getItem('password'));
        }

      }
     

       },[]);


  return (
    <>
    {!autoLogin && 
    <div className={classes.root}>
          <Paper className={classes.Loginpaper} elevation={0}>
            <form onSubmit={handleSubmit}>
              <Grid>
                <Grid item>
                  <img src={vurellaACD} />
                </Grid>
                <Grid item style={{paddingBottom:'15px'}}>
                  <Typography variant="h5" style={{color:'#0288d1'}}>{t('login.agentlogin')}</Typography>
                </Grid>
                <Grid item>
                  <TextField
                    id="username"
                    label={t('login.username')}
                    variant="outlined"
                    defaultValue = {userN}
                    required
                  />
                </Grid>
                <Grid item>
                  <TextField
                    id="password"
                    label={t('login.password')}
                    type="password"
                    variant="outlined"
                    defaultValue = {passW}
                    required
                  />
                </Grid>
                <Grid item style={{marginTop:'12px'}}>
                  <Button disabled={btnState} variant="contained" color="primary" type="submit" startIcon={<PersonIcon/>}>
                    {t('login.loginbtn')} {btnState && <CircularProgress size={24} className={classes.buttonProgress}/>}
                  </Button>
                  
                </Grid>
              </Grid>
            </form>
          </Paper>
          <div style={{position:'fixed', left:0, bottom:30, width:'100%', textAlign:'center'}}><img src={rainbowLogo} width='45' height='45'/></div>
          <Snackbar open={errorOpen} autoHideDuration={6000} onClose={handleErrorClose}>
          <Alert onClose={handleErrorClose} severity="error">
          Unable to login, {errorMsg}
        </Alert>
      </Snackbar>
        </div> 
    }
    {autoLogin && <div className = {classes.autologinchild}>
    <img src={rainbowGif} width="100px" height="100px" />
    <Typography variant="h6" style={{color:'#000000'}}>Logging into Rainbow</Typography>
    </div>}
    </>
  );
}
